import { useSelector } from 'react-redux';
import type { ReduxStore } from '../redux/types';

export const useStoredExperiment = (testName) => {
  try {
    const experiments = useSelector<ReduxStore, ReduxStore['experiments']>(
      (store) => store.experiments
    );

    const experiment = experiments?.find(
      (test) => test.experimentName === testName
    );

    return experiment ?? null;
  } catch (e) {
    return null;
  }
};
